import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommissionAdjustDisposition, CommissionCreditAdjustDisposition } from 'src/app/model/other-catalogs-models';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';

@Component({
  selector: 'app-modal-commission-adjust-disposition',
  templateUrl: './modal-commission-adjust-disposition.component.html',
  styleUrls: ['./modal-commission-adjust-disposition.component.css']
})
export class ModalCommissionAdjustDispositionComponent implements OnInit {

  @Input() CommissionAdjustDisposition: CommissionAdjustDisposition;

  constructor(private commissionSalePromotionsService:CommissionSalePromotionsService,
    private toastr:ToastrService,
    private modalService: NgbModal) { }
    public comentarioAjuste: string='';
    public ajuste : boolean =false;
    public userId =Number(localStorage.getItem('com_token'));

    public request: CommissionCreditAdjustDisposition[]=[];

  public claveEmpleadoDispersion: string ;
  public comisionTotal: number  ;
  public ajusteComision: number  ;
  public comisionFinal : number ;
  public userCreate: number ;
  public Nota: string;
  public CreditsId: number []= [];
  public date: Date = new Date()

  
  ngOnInit() {
    
    console.log('Date = ' + this.date)
  }

  adjustCommission(){
    this.CommissionAdjustDisposition.comisionFinal= (this.CommissionAdjustDisposition.comisionTotal + this.CommissionAdjustDisposition.ajusteComision);
    this.CommissionAdjustDisposition.comisionFinal.toFixed(2);
    
    if(this.CommissionAdjustDisposition.ajusteComision == 0 || this.CommissionAdjustDisposition.comisionTotal == this.CommissionAdjustDisposition.comisionFinal || this.CommissionAdjustDisposition.comisionFinal < 0){
      this.ajuste = false;
      if(this.CommissionAdjustDisposition.comisionFinal < 0){
        this.toastr.error('La comisión final no puede ser menor que 0');
      } else{
        this.ajuste = true;
        this.CommissionAdjustDisposition.Nota = this.comentarioAjuste;
      }
    } 
    
  }

  SaveAdjust(){
   
    console.log(this.CommissionAdjustDisposition)
    this.SetCommissionDispositionDetail(1);
    this.SetCreditAdjust();
  
  }
  
  SetCommissionDispositionDetail=(action: number)=> {
   
    this.claveEmpleadoDispersion = this.CommissionAdjustDisposition.ClaveEmpleadoDispersion
    this.comisionTotal = this.CommissionAdjustDisposition.comisionTotal
    this.ajusteComision = this.CommissionAdjustDisposition.ajusteComision
    this.comisionFinal = this.CommissionAdjustDisposition.comisionFinal
    this.userCreate = this.userId
    this.Nota = this.CommissionAdjustDisposition.Nota
   
    
    this.commissionSalePromotionsService.SetCommissionDispositionDetail(this.claveEmpleadoDispersion, this.comisionTotal, this.ajusteComision, this.comisionFinal , this.userCreate, action ,  this.Nota )
    
      .pipe(
        tap((resp:any)=> {

          console.error(resp.data)
        this.modalService.dismissAll();
        this.toastr.success("Las comisiones se han guardado con éxito. Consulte de nuevo para validar")
        
        }),
        catchError(error=> {
          console.log(error)
          
          return of(this.toastr.error('Ocurrió un error al leer el catálogo asesores.'));
        })
      )
      .subscribe();
  }

  close=()=> {
    console.log(this.CreditsId)
    //this.SetCreditAdjust();
    this.modalService.dismissAll();
  }

  SetCreditAdjust=()=> {
   

    this.CreditsId.forEach((re)=>{
      this.request.push({ creditId: re, claveDispersion: this.CommissionAdjustDisposition.ClaveEmpleadoDispersion,usuario: this.userId, fechaCreacion: '2023-07-04'  })
      
    });

  
    console.error(this.request)
   
    
    this.commissionSalePromotionsService.saveCreditAdjust(this.request )
    
      .pipe(
        tap((resp:any)=> {

          console.error(resp.data)
        this.modalService.dismissAll();
        this.toastr.success("Creditos Guardados")
        
        }),
        catchError(error=> {
          console.log(error)
          
          return of(this.toastr.error('Ocurrió un error al leer el catálogo asesores.'));
        })
      )
      .subscribe();
  }

}
